import React from 'react';
import { useInfiniteHits } from 'react-instantsearch';

import { MeditationCard } from '~/src/components/cards';
import {
  HitsContainer,
  useFallbackHits,
  useOnItemClickAnalytics,
} from '~/src/components/FinderPage';

import type { CardItem } from './CardItem';
import type { Hit } from 'instantsearch.js/es/types/results';

const Fallback: React.FC = () => {
  const { hits, loading } = useFallbackHits<CardItem>();

  return (
    <HitsContainer.NoResultsFallbackContainer loading={loading}>
      {hits.map(item => {
        return <MeditationCard key={item.id} item={item} />;
      })}
    </HitsContainer.NoResultsFallbackContainer>
  );
};

export const Hits: React.FC = () => {
  const { hits, results } = useInfiniteHits<Hit<CardItem>>();

  const onClick = useOnItemClickAnalytics<CardItem>({
    indexName: results?.index,
    componentName: 'ClassPage',
  });
  return (
    <HitsContainer noResultsFallback={<Fallback />}>
      <HitsContainer.HitsList>
        {hits.map(item => {
          return <MeditationCard item={item} onClick={() => onClick(item)} key={item.id} />;
        })}
      </HitsContainer.HitsList>
    </HitsContainer>
  );
};
